import React from "react";
import Loader from "./loader";
import themePropTypes from "../theme-prop-types";

const LoaderInDialog = ({ textDelay = 0, text }) => (
  <div className='loader-in-dialog-web-sdk'>
    <div className='dialog-overlay-web-sdk'>
      <div className='dialog-wrapper-web-sdk'>
        <div className='dialog-web-sdk dialog-loader-web-sdk'>
          <Loader text={text} textDelay={textDelay} />
        </div>
      </div>
    </div>
  </div>
);

LoaderInDialog.propTypes = themePropTypes.loader;

export default LoaderInDialog;
